import * as React from 'react';
import { WidgetTypeWrapper } from 'services/WidgetTypes/WidgetTypeWrapper';
import IndexedList from 'models/Collections/IndexedList';

// HyperSpaceColumnChartWidget
import { HyperSpaceColumnChartWidgetOptionsImpl } from '../../widgets/hyperSpace/HyperSpaceColumnChartWidget/options';
import { HyperSpaceColumnChartWidgetTunables } from '../../widgets/hyperSpace/HyperSpaceColumnChartWidget/tunables';
const HyperSpaceColumnChartWidget = React.lazy(() =>
    import(
        /* webpackChunkName: "HyperSpaceColumnChartWidget" */ '../../widgets/hyperSpace/HyperSpaceColumnChartWidget/HyperSpaceColumnChartWidget'
    )
);

// HyperSpaceBarChartWidget
import { HyperSpaceBarChartWidgetOptionsImpl } from '../../widgets/hyperSpace/HyperSpaceBarChartWidget/options';
import { HyperSpaceBarChartWidgetTunables } from '../../widgets/hyperSpace/HyperSpaceBarChartWidget/tunables';
const HyperSpaceBarChartWidget = React.lazy(() =>
    import(
        /* webpackChunkName: "HyperSpaceBarChartWidget" */ '../../widgets/hyperSpace/HyperSpaceBarChartWidget/HyperSpaceBarChartWidget'
    )
);

// HyperSpaceStackedBarChartWidget
import { HyperSpaceStackedBarChartWidgetOptionsImpl } from '../../widgets/hyperSpace/HyperSpaceStackedBarChartWidget/options';
import { HyperSpaceStackedBarChartWidgetTunables } from '../../widgets/hyperSpace/HyperSpaceStackedBarChartWidget/tunables';
const HyperSpaceStackedBarChartWidget = React.lazy(() =>
    import(
        /* webpackChunkName: "HyperSpaceStackedBarChartWidget" */ '../../widgets/hyperSpace/HyperSpaceStackedBarChartWidget/HyperSpaceStackedBarChartWidget'
    )
);

// HyperSpaceStackedColumnChartWidget
import { HyperSpaceStackedColumnChartWidgetOptionsImpl } from '../../widgets/hyperSpace/HyperSpaceStackedColumnChartWidget/options';
import { HyperSpaceStackedColumnChartWidgetTunables } from '../../widgets/hyperSpace/HyperSpaceStackedColumnChartWidget/tunables';
const HyperSpaceStackedColumnChartWidget = React.lazy(() =>
    import(
        /* webpackChunkName: "HyperSpaceStackedColumnChartWidget" */ '../../widgets/hyperSpace/HyperSpaceStackedColumnChartWidget/HyperSpaceStackedColumnChartWidget'
    )
);

// HyperSpaceLineChartWidget
import { HyperSpaceLineChartWidgetOptionsImpl } from '../../widgets/hyperSpace/HyperSpaceLineChartWidget/options';
import { HyperSpaceLineChartWidgetTunables } from '../../widgets/hyperSpace/HyperSpaceLineChartWidget/tunables';
const HyperSpaceLineChartWidget = React.lazy(() =>
    import(
        /* webpackChunkName: "HyperSpaceLineChartWidget" */ '../../widgets/hyperSpace/HyperSpaceLineChartWidget/HyperSpaceLineChartWidget'
    )
);

// HyperSpaceAreaChartWidget
import { HyperSpaceAreaChartWidgetOptionsImpl } from '../../widgets/hyperSpace/HyperSpaceAreaChartWidget/options';
import { HyperSpaceAreaChartWidgetTunables } from '../../widgets/hyperSpace/HyperSpaceAreaChartWidget/tunables';
const HyperSpaceAreaChartWidget = React.lazy(() =>
    import(
        /* webpackChunkName: "HyperSpaceAreaChartWidget" */ '../../widgets/hyperSpace/HyperSpaceAreaChartWidget/HyperSpaceAreaChartWidget'
    )
);

// HyperSpaceDualAxisChartWidget
import { HyperSpaceDualAxisChartWidgetOptionsImpl } from '../../widgets/hyperSpace/HyperSpaceDualAxisChartWidget/options';
import { HyperSpaceDualAxisChartWidgetTunables } from '../../widgets/hyperSpace/HyperSpaceDualAxisChartWidget/tunables';
const HyperSpaceDualAxisChartWidget = React.lazy(() =>
    import(
        /* webpackChunkName: "HyperSpaceDualAxisChartWidget" */ '../../widgets/hyperSpace/HyperSpaceDualAxisChartWidget/HyperSpaceDualAxisChartWidget'
    )
);

// HyperSpaceComboChartWidget
import { HyperSpaceComboChartWidgetOptionsImpl } from '../../widgets/hyperSpace/HyperSpaceComboChartWidget/options';
import { HyperSpaceComboChartWidgetTunables } from '../../widgets/hyperSpace/HyperSpaceComboChartWidget/tunables';
const HyperSpaceComboChartWidget = React.lazy(() =>
    import(
        /* webpackChunkName: "HyperSpaceComboChartWidget" */ '../../widgets/hyperSpace/HyperSpaceComboChartWidget/HyperSpaceComboChartWidget'
    )
);

// HyperSpaceBubblePlotChartWidget
import { HyperSpaceBubblePlotChartWidgetOptionsImpl } from '../../widgets/hyperSpace/HyperSpaceBubblePlotChartWidget/options';
import { HyperSpaceBubblePlotChartWidgetTunables } from '../../widgets/hyperSpace/HyperSpaceBubblePlotChartWidget/tunables';
const HyperSpaceBubblePlotChartWidget = React.lazy(() =>
    import(
        /* webpackChunkName: "HyperSpaceBubblePlotChartWidget" */ '../../widgets/hyperSpace/HyperSpaceBubblePlotChartWidget/HyperSpaceBubblePlotChartWidget'
    )
);

// HyperSpaceAxisBubbleChartWidget
import { HyperSpaceAxisBubbleChartWidgetOptionsImpl } from '../../widgets/hyperSpace/HyperSpaceAxisBubbleChartWidget/options';
import { HyperSpaceAxisBubbleChartWidgetTunables } from '../../widgets/hyperSpace/HyperSpaceAxisBubbleChartWidget/tunables';
const HyperSpaceAxisBubbleChartWidget = React.lazy(() =>
    import(
        /* webpackChunkName: "HyperSpaceAxisBubbleChartWidget" */ '../../widgets/hyperSpace/HyperSpaceAxisBubbleChartWidget/HyperSpaceAxisBubbleChartWidget'
    )
);

// HyperSpaceQuadrantMatrixWidget
import { HyperSpaceQuadrantMatrixWidgetOptionsImpl } from '../../widgets/hyperSpace/HyperSpaceQuadrantMatrixWidget/options';
import { HyperSpaceQuadrantMatrixWidgetTunables } from '../../widgets/hyperSpace/HyperSpaceQuadrantMatrixWidget/tunables';
const HyperSpaceQuadrantMatrixWidget = React.lazy(() =>
    import(
        /* webpackChunkName: "HyperSpaceQuadrantMatrixWidget" */ '../../widgets/hyperSpace/HyperSpaceQuadrantMatrixWidget/HyperSpaceQuadrantMatrixWidget'
    )
);

// HyperSpacePieChartWidget
import { HyperSpacePieChartWidgetOptionsImpl } from '../../widgets/hyperSpace/HyperSpacePieChartWidget/options';
import { HyperSpacePieChartWidgetTunables } from '../../widgets/hyperSpace/HyperSpacePieChartWidget/tunables';
const HyperSpacePieChartWidget = React.lazy(() =>
    import(
        /* webpackChunkName: "HyperSpacePieChartWidget" */ '../../widgets/hyperSpace/HyperSpacePieChartWidget/HyperSpacePieChartWidget'
    )
);

// HyperSpaceTreeMapWidget
import { HyperSpaceTreeMapWidgetOptionsImpl } from '../../widgets/hyperSpace/HyperSpaceTreeMapWidget/options';
import { HyperSpaceTreeMapWidgetTunables } from '../../widgets/hyperSpace/HyperSpaceTreeMapWidget/tunables';
const HyperSpaceTreeMapWidget = React.lazy(() =>
    import(
        /* webpackChunkName: "HyperSpaceTreeMapWidget" */ '../../widgets/hyperSpace/HyperSpaceTreeMapWidget/HyperSpaceTreeMapWidget'
    )
);

// HyperSpaceAlertsWidget
import { HyperSpaceAlertsWidgetOptionsImpl } from '../../widgets/hyperSpace/HyperSpaceAlertsWidget/options';
import { HyperSpaceAlertsWidgetTunables } from '../../widgets/hyperSpace/HyperSpaceAlertsWidget/tunables';
import { FEATURE_FLAG } from 'services/Auth/AuthService';
const HyperSpaceAlertsWidget = React.lazy(() =>
    import(
        /* webpackChunkName: "HyperSpaceAlertsWidget" */ '../../widgets/hyperSpace/HyperSpaceAlertsWidget/HyperSpaceAlertsWidget'
    )
);
export const addHyperSpaceCharts = (indexedList: IndexedList<WidgetTypeWrapper>) => {
    indexedList.add(
        new WidgetTypeWrapper({
            id: 'hyperSpaceBarChart',
            idTemplate: 'hyper-space-bar-chart',
            name: 'Bar Chart - NEW',
            dataType: 'analytics',
            component: HyperSpaceBarChartWidget,
            supportsWidgetLabelDateRange: true,
            tags: ['analytics'],
            minProjections: 1,
            maxProjections: 12,
            minGroupBys: 0,
            maxGroupBys: 1,
            supportsPanelPadding: true,
            supportsPreviousPeriod: true,
            groupByLabels: ['x', 'series'],
            optionsType: HyperSpaceBarChartWidgetOptionsImpl,
            supportsWidgetLabel: true,
            supportsLabel: true,
            supportsColorPalette: true,
            supportsDisableColorPalette: true,
            supportsSpacingMax: 25,
            supportsPadding: true,
            supportsPaddingMin: 15,
            supportsPaddingMax: 35,
            supportsAnimationTunables: false,
            supportsAnimation: false,
            supportsPresentationsPlayer: false,
            supportsAnimationDelay: false,
            supportsAnimationLength: false,
            supportsThresholds: true,
            supportsHistory: true,
            supportsBlacklist: true,
            thresholdType: 'multipleLine',
            supportsMainColor: true,
            supportsThemeTypography: true,
            supportsSentiment: true,
            thumbSrc: 'template-bar-chart.jpg',
            supportsThemeColor: true,
            supportsThemeImage: true,
            supportsThemeImageOpacity: false,
            supportsThemeImageCircleMask: true,
            supportsThemeImageSize: true,
            supportsThemeImagePosition: true,
            supportsSortBy: true,
            tunables: HyperSpaceBarChartWidgetTunables,
            ifMultipleMetricsNoDimensions: true,
        })
    );

    // hyperSpaceColumnChart
    indexedList.add(
        new WidgetTypeWrapper({
            id: 'hyperSpaceColumnChart',
            idTemplate: 'hyper-space-column-chart',
            name: 'Column Chart - NEW',
            dataType: 'analytics',
            component: HyperSpaceColumnChartWidget,
            supportsWidgetLabelDateRange: true,
            tags: ['analytics'],
            minProjections: 1,
            maxProjections: 12,
            minGroupBys: 0,
            maxGroupBys: 1,
            supportsPanelPadding: true,
            supportsPreviousPeriod: true,
            groupByLabels: ['x', 'series'],
            optionsType: HyperSpaceColumnChartWidgetOptionsImpl,
            supportsWidgetLabel: true,
            supportsLabel: true,
            supportsColorPalette: true,
            supportsDisableColorPalette: true,
            supportsSpacingMax: 25,
            supportsPadding: true,
            supportsPaddingMin: 15,
            supportsPaddingMax: 35,
            supportsAnimationTunables: false,
            supportsAnimation: false,
            supportsPresentationsPlayer: false,
            supportsAnimationDelay: false,
            supportsAnimationLength: false,
            supportsThresholds: true,
            supportsHistory: true,
            supportsBlacklist: true,
            thresholdType: 'multipleLine',
            supportsMainColor: true,
            supportsThemeTypography: true,
            supportsSentiment: true,
            thumbSrc: 'template-column-chart.jpg',
            supportsThemeColor: true,
            supportsThemeImage: true,
            supportsThemeImageOpacity: false,
            supportsThemeImageCircleMask: true,
            supportsThemeImageSize: true,
            supportsThemeImagePosition: true,
            supportsSortBy: true,
            tunables: HyperSpaceColumnChartWidgetTunables,
            ifMultipleMetricsNoDimensions: true,
        })
    );

    // hyperSpaceLineChart
    indexedList.add(
        new WidgetTypeWrapper({
            id: 'hyperSpaceLineChart',
            idTemplate: 'hyper-space-line-chart',
            name: 'Line Chart - NEW',
            dataType: 'analytics',
            component: HyperSpaceLineChartWidget,
            supportsWidgetLabelDateRange: true,
            tags: ['analytics'],
            minProjections: 1,
            maxProjections: 12,
            minGroupBys: 1,
            maxGroupBys: 2,
            supportsMultipleTimePeriods: true,
            supportsPanelPadding: true,
            supportsPreviousPeriod: true,
            groupByLabels: ['x', 'series'],
            optionsType: HyperSpaceLineChartWidgetOptionsImpl,
            supportsWidgetLabel: true,
            supportsLabel: true,
            supportsColorPalette: true,
            supportsDisableColorPalette: true,
            supportsSpacingMax: 25,
            supportsPadding: true,
            supportsPaddingMin: 15,
            supportsPaddingMax: 35,
            supportsAnimationTypes: ['fade', 'none'],
            supportsAnimationTunables: true,
            supportsAnimation: true,
            supportsPresentationsPlayer: true,
            supportsAnimationLength: true,
            supportsAnimationDelay: true,
            supportsThresholds: true,
            supportsHistory: true,
            supportsBlacklist: true,
            thresholdType: 'multipleLine',
            supportsMainColor: true,
            supportsThemeTypography: true,
            supportsSentiment: true,
            thumbSrc: 'template-line-chart.jpg',
            supportsThemeColor: true,
            supportsThemeImage: true,
            supportsThemeImageOpacity: false,
            supportsThemeImageCircleMask: true,
            supportsThemeImageSize: true,
            supportsThemeImagePosition: true,
            supportsSortBy: true,
            tunables: HyperSpaceLineChartWidgetTunables,
        })
    );

    // hyperSpaceAreaChart
    indexedList.add(
        new WidgetTypeWrapper({
            id: 'hyperSpaceAreaChart',
            idTemplate: 'hyper-space-area-chart',
            name: 'Area Chart - NEW',
            dataType: 'analytics',
            component: HyperSpaceAreaChartWidget,
            supportsWidgetLabelDateRange: true,
            tags: ['analytics'],
            minProjections: 1,
            maxProjections: 12,
            minGroupBys: 1,
            maxGroupBys: 2,
            supportsPanelPadding: true,
            supportsPreviousPeriod: true,
            groupByLabels: ['x', 'series'],
            optionsType: HyperSpaceAreaChartWidgetOptionsImpl,
            supportsWidgetLabel: true,
            supportsLabel: true,
            supportsColorPalette: true,
            supportsDisableColorPalette: true,
            supportsSpacingMax: 25,
            supportsPadding: true,
            supportsPaddingMin: 15,
            supportsPaddingMax: 35,
            // supportsAnimationTypes: ['fade', 'drop', 'lift', 'slide_in_out', 'scale_in_out'],
            supportsAnimationTunables: false,
            supportsAnimation: false,
            supportsPresentationsPlayer: false,
            supportsAnimationDelay: false,
            supportsAnimationLength: false,
            supportsThresholds: true,
            supportsHistory: true,
            supportsBlacklist: true,
            thresholdType: 'multipleLine',
            supportsMainColor: true,
            supportsThemeTypography: true,
            supportsSentiment: true,
            thumbSrc: 'template-line-chart.jpg',
            supportsThemeColor: true,
            supportsThemeImage: true,
            supportsThemeImageOpacity: false,
            supportsThemeImageCircleMask: true,
            supportsThemeImageSize: true,
            supportsThemeImagePosition: true,
            supportsSortBy: true,
            tunables: HyperSpaceAreaChartWidgetTunables,
        })
    );

    // hyperSpaceDualAxisChart
    indexedList.add(
        new WidgetTypeWrapper({
            id: 'hyperSpaceDualAxisChart',
            idTemplate: 'hyper-space-dual-axis-chart',
            name: 'Dual Axis Chart - NEW',
            dataType: 'analytics',
            component: HyperSpaceDualAxisChartWidget,
            supportsWidgetLabelDateRange: true,
            tags: ['analytics'],
            minProjections: 2,
            maxProjections: 2,
            minGroupBys: 1,
            maxGroupBys: 1,
            supportsPanelPadding: true,
            supportsPreviousPeriod: true,
            groupByLabels: ['x', 'series'],
            optionsType: HyperSpaceDualAxisChartWidgetOptionsImpl,
            supportsWidgetLabel: true,
            supportsLabel: true,
            supportsColorPalette: true,
            supportsDisableColorPalette: true,
            supportsSpacingMax: 25,
            supportsPadding: true,
            supportsPaddingMin: 15,
            supportsPaddingMax: 35,
            // supportsAnimationTypes: ['fade', 'drop', 'lift', 'slide_in_out', 'scale_in_out'],
            supportsAnimationTunables: false,
            supportsAnimation: false,
            supportsPresentationsPlayer: false,
            supportsAnimationDelay: false,
            supportsAnimationLength: false,
            supportsThresholds: true,
            supportsHistory: true,
            supportsBlacklist: true,
            thresholdType: 'multipleLine',
            supportsMainColor: true,
            supportsThemeTypography: true,
            supportsSentiment: true,
            thumbSrc: 'template-line-chart.jpg',
            supportsThemeColor: true,
            supportsThemeImage: true,
            supportsThemeImageOpacity: false,
            supportsThemeImageCircleMask: true,
            supportsThemeImageSize: true,
            supportsThemeImagePosition: true,
            supportsSortBy: true,
            tunables: HyperSpaceDualAxisChartWidgetTunables,
        })
    );

    // hyperSpaceComboChart
    indexedList.add(
        new WidgetTypeWrapper({
            id: 'hyperSpaceComboChart',
            idTemplate: 'hyper-space-combo-chart',
            name: 'Combo Chart - NEW',
            dataType: 'analytics',
            component: HyperSpaceComboChartWidget,
            supportsWidgetLabelDateRange: true,
            tags: ['analytics'],
            minProjections: 1,
            maxProjections: 5,
            minGroupBys: 1,
            maxGroupBys: 2,
            supportsPanelPadding: true,
            supportsPreviousPeriod: true,
            groupByLabels: ['x', 'series'],
            optionsType: HyperSpaceComboChartWidgetOptionsImpl,
            supportsWidgetLabel: true,
            supportsLabel: true,
            supportsColorPalette: true,
            supportsDisableColorPalette: true,
            supportsSpacingMax: 25,
            supportsPadding: true,
            supportsPaddingMin: 15,
            supportsPaddingMax: 35,
            // supportsAnimationTypes: ['fade', 'drop', 'lift', 'slide_in_out', 'scale_in_out'],
            supportsAnimationTunables: false,
            supportsAnimation: false,
            supportsPresentationsPlayer: false,
            supportsAnimationDelay: false,
            supportsAnimationLength: false,
            supportsThresholds: true,
            supportsHistory: true,
            supportsBlacklist: true,
            thresholdType: 'multipleLine',
            supportsMainColor: true,
            supportsThemeTypography: true,
            supportsSentiment: true,
            thumbSrc: 'template-line-chart.jpg',
            supportsThemeColor: true,
            supportsThemeImage: true,
            supportsThemeImageOpacity: false,
            supportsThemeImageCircleMask: true,
            supportsThemeImageSize: true,
            supportsThemeImagePosition: true,
            supportsSortBy: true,
            tunables: HyperSpaceComboChartWidgetTunables,
        })
    );

    indexedList.add(
        new WidgetTypeWrapper({
            id: 'hyperSpaceBubblePlotChart',
            idTemplate: 'hyper-space-bubble-plot-chart',
            name: 'BubblePlot Chart - NEW',
            dataType: 'analytics',
            component: HyperSpaceBubblePlotChartWidget,
            supportsWidgetLabelDateRange: true,
            tags: ['analytics'],
            groupByLabels: ['x', 'series'],
            metricLabels: ['y', 'z'],
            minProjections: 1,
            maxProjections: 2,
            minGroupBys: 1,
            maxGroupBys: 2,
            supportsPanelPadding: true,
            supportsPreviousPeriod: true,
            optionsType: HyperSpaceBubblePlotChartWidgetOptionsImpl,
            supportsWidgetLabel: true,
            supportsLabel: true,
            supportsColorPalette: true,
            supportsDisableColorPalette: true,
            supportsSpacingMax: 25,
            supportsPadding: true,
            supportsPaddingMin: 15,
            supportsPaddingMax: 35,
            supportsAnimationTunables: false,
            supportsAnimation: false,
            supportsPresentationsPlayer: false,
            supportsAnimationDelay: false,
            supportsAnimationLength: false,
            supportsThresholds: true,
            supportsHistory: true,
            supportsBlacklist: true,
            // thresholdType: 'multipleLine',
            supportsMainColor: true,
            supportsThemeTypography: true,
            supportsSentiment: true,
            thumbSrc: 'template-line-chart.jpg',
            supportsThemeColor: true,
            supportsThemeImage: true,
            supportsThemeImageOpacity: false,
            supportsThemeImageCircleMask: true,
            supportsThemeImageSize: true,
            supportsThemeImagePosition: true,
            supportsSortBy: true,
            tunables: HyperSpaceBubblePlotChartWidgetTunables,
        })
    );

    // hyperSpaceBubblePlotChart
    indexedList.add(
        new WidgetTypeWrapper({
            id: 'hyperSpaceAxisBubbleChart',
            idTemplate: 'hyper-space-axis-bubble-chart',
            name: 'AxisBubble Chart - NEW',
            dataType: 'analytics',
            component: HyperSpaceAxisBubbleChartWidget,
            supportsWidgetLabelDateRange: true,
            tags: ['analytics'],
            groupByLabels: ['series'],
            metricLabels: ['x', 'y', 'z'],
            minProjections: 2,
            maxProjections: 3,
            minGroupBys: 1,
            maxGroupBys: 1,
            supportsPanelPadding: true,
            supportsPreviousPeriod: true,
            optionsType: HyperSpaceAxisBubbleChartWidgetOptionsImpl,
            supportsWidgetLabel: true,
            supportsLabel: true,
            supportsColorPalette: true,
            supportsDisableColorPalette: true,
            supportsSpacingMax: 25,
            supportsPadding: true,
            supportsPaddingMin: 15,
            supportsPaddingMax: 35,
            supportsAnimationTunables: false,
            supportsAnimation: false,
            supportsPresentationsPlayer: false,
            supportsAnimationDelay: false,
            supportsAnimationLength: false,
            supportsThresholds: true,
            supportsHistory: true,
            supportsBlacklist: true,
            // thresholdType: 'multipleLine',
            supportsMainColor: true,
            supportsThemeTypography: true,
            supportsSentiment: true,
            thumbSrc: 'template-line-chart.jpg',
            supportsThemeColor: true,
            supportsThemeImage: true,
            supportsThemeImageOpacity: false,
            supportsThemeImageCircleMask: true,
            supportsThemeImageSize: true,
            supportsThemeImagePosition: true,
            supportsSortBy: true,
            tunables: HyperSpaceAxisBubbleChartWidgetTunables,
        })
    );
    // HyperSpaceQuadrantMatrixWidget
    indexedList.add(
        new WidgetTypeWrapper({
            id: 'hyperSpaceQuadrantMatrix',
            idTemplate: 'hyper-space-axis-bubble-chart',
            name: 'Quadrant Matrix - NEW',
            dataType: 'analytics',
            component: HyperSpaceQuadrantMatrixWidget,
            supportsWidgetLabelDateRange: true,
            tags: ['analytics'],
            groupByLabels: ['series'],
            metricLabels: ['x', 'y', 'z'],
            minProjections: 2,
            maxProjections: 3,
            minGroupBys: 1,
            maxGroupBys: 1,
            supportsPanelPadding: true,
            supportsPreviousPeriod: true,
            optionsType: HyperSpaceQuadrantMatrixWidgetOptionsImpl,
            supportsWidgetLabel: true,
            supportsLabel: true,
            supportsColorPalette: true,
            supportsDisableColorPalette: true,
            supportsSpacingMax: 25,
            supportsPadding: true,
            supportsPaddingMin: 15,
            supportsPaddingMax: 35,
            supportsAnimationTunables: false,
            supportsAnimation: false,
            supportsAnimationDelay: false,
            supportsAnimationLength: false,
            supportsThresholds: true,
            supportsHistory: true,
            supportsBlacklist: true,
            // thresholdType: 'multipleLine',
            supportsMainColor: true,
            supportsThemeTypography: true,
            supportsSentiment: true,
            thumbSrc: 'template-line-chart.jpg',
            supportsThemeColor: true,
            supportsThemeImage: true,
            supportsThemeImageOpacity: false,
            supportsThemeImageCircleMask: true,
            supportsThemeImageSize: true,
            supportsThemeImagePosition: true,
            supportsSortBy: true,
            tunables: HyperSpaceQuadrantMatrixWidgetTunables,
        })
    );

    // hyperSpaceComboChart
    indexedList.add(
        new WidgetTypeWrapper({
            id: 'hyperSpaceComboChart',
            idTemplate: 'hyper-space-combo-chart',
            name: 'Combo Chart - NEW',
            dataType: 'analytics',
            component: HyperSpaceComboChartWidget,
            supportsWidgetLabelDateRange: true,
            tags: ['analytics'],
            minProjections: 1,
            maxProjections: 5,
            minGroupBys: 1,
            maxGroupBys: 2,
            supportsPanelPadding: true,
            supportsPreviousPeriod: true,
            groupByLabels: ['x', 'series'],
            optionsType: HyperSpaceComboChartWidgetOptionsImpl,
            supportsWidgetLabel: true,
            supportsLabel: true,
            supportsColorPalette: true,
            supportsDisableColorPalette: true,
            supportsSpacingMax: 25,
            supportsPadding: true,
            supportsPaddingMin: 15,
            supportsPaddingMax: 35,
            supportsAnimationTunables: false,
            supportsAnimation: false,
            supportsPresentationsPlayer: false,
            supportsAnimationDelay: false,
            supportsAnimationLength: false,
            supportsThresholds: true,
            supportsHistory: true,
            supportsBlacklist: true,
            thresholdType: 'multipleLine',
            supportsMainColor: true,
            supportsThemeTypography: true,
            supportsSentiment: true,
            thumbSrc: 'template-line-chart.jpg',
            supportsThemeColor: true,
            supportsThemeImage: true,
            supportsThemeImageOpacity: false,
            supportsThemeImageCircleMask: true,
            supportsThemeImageSize: true,
            supportsThemeImagePosition: true,
            supportsSortBy: true,
            tunables: HyperSpaceComboChartWidgetTunables,
        })
    );

    indexedList.add(
        new WidgetTypeWrapper({
            id: 'hyperSpacePieChart',
            idTemplate: 'hyper-space-pie-chart',
            name: 'Pie Chart - NEW',
            dataType: 'analytics',
            component: HyperSpacePieChartWidget,
            supportsWidgetLabelDateRange: true,
            tags: ['analytics'],
            minProjections: 1,
            maxProjections: 12,
            minGroupBys: 0,
            maxGroupBys: 1,
            supportsPanelPadding: true,
            supportsPreviousPeriod: true,
            groupByLabels: ['x', 'series'],
            optionsType: HyperSpacePieChartWidgetOptionsImpl,
            supportsWidgetLabel: true,
            supportsLabel: true,
            supportsColorPalette: true,
            supportsDisableColorPalette: true,
            supportsSpacingMax: 25,
            supportsPadding: true,
            supportsPaddingMin: 15,
            supportsPaddingMax: 35,
            supportsAnimationTunables: false,
            supportsAnimation: false,
            supportsPresentationsPlayer: false,
            supportsAnimationDelay: false,
            supportsAnimationLength: false,
            supportsThresholds: true,
            supportsHistory: true,
            supportsBlacklist: true,
            thresholdType: 'multipleLine',
            supportsMainColor: true,
            supportsThemeTypography: true,
            supportsSentiment: true,
            thumbSrc: 'template-pie-chart.jpg',
            supportsThemeColor: true,
            supportsThemeImage: true,
            supportsThemeImageOpacity: false,
            supportsThemeImageCircleMask: true,
            supportsThemeImageSize: true,
            supportsThemeImagePosition: true,
            supportsSortBy: true,
            tunables: HyperSpacePieChartWidgetTunables,
        })
    );

    // hyperspace stackedBar chart
    indexedList.add(
        new WidgetTypeWrapper({
            id: 'hyperSpaceStackedBarChart',
            idTemplate: 'hyper-stacked-bar-chart',
            name: 'Stacked Bar Chart - NEW',
            dataType: 'analytics',
            component: HyperSpaceStackedBarChartWidget,
            supportsWidgetLabelDateRange: true,
            tags: ['analytics'],
            minProjections: 1,
            maxProjections: 1,
            minGroupBys: 2,
            maxGroupBys: 2,
            supportsPanelPadding: true,
            supportsPreviousPeriod: false,
            optionsType: HyperSpaceStackedBarChartWidgetOptionsImpl,
            supportsWidgetLabel: true,
            groupByLabels: ['x', 'series'],
            supportsLabel: true,
            supportsColorPalette: true,
            supportsDisableColorPalette: true,
            supportsSpacing: true,
            supportsSpacingMax: 25,
            supportsDisableLegend: true,
            supportsAnimationTunables: true,
            supportsAnimation: false,
            supportsPresentationsPlayer: false,
            supportsAnimationDelay: true,
            supportsAnimationLength: true,
            supportsStackedTypes: true,
            supportsLegend: true,
            supportsLegendOrientation: true,
            supportsShowYAxis: true,
            supportsMainColor: true,
            supportsHistory: true,
            supportsThemeTypography: true,
            thumbSrc: 'template-stacked-bar-chart.jpg',
            supportsThemeColor: true,
            tunables: HyperSpaceStackedBarChartWidgetTunables,
            supportsSortBy: true,
        })
    );

    // hyperspace stackedColumn chart
    indexedList.add(
        new WidgetTypeWrapper({
            id: 'hyperSpaceStackedColumnChart',
            idTemplate: 'hyper-stacked-column-chart',
            name: 'Stacked Column Chart - NEW',
            dataType: 'analytics',
            component: HyperSpaceStackedColumnChartWidget,
            supportsWidgetLabelDateRange: true,
            tags: ['analytics'],
            minProjections: 1,
            maxProjections: 1,
            minGroupBys: 2,
            maxGroupBys: 2,
            supportsPanelPadding: true,
            supportsPreviousPeriod: false,
            optionsType: HyperSpaceStackedColumnChartWidgetOptionsImpl,
            supportsWidgetLabel: true,
            groupByLabels: ['x', 'series'],
            supportsLabel: true,
            supportsColorPalette: true,
            supportsDisableColorPalette: true,
            supportsSpacing: true,
            supportsSpacingMax: 25,
            supportsDisableLegend: true,
            supportsAnimationTunables: true,
            supportsAnimation: false,
            supportsPresentationsPlayer: false,
            supportsAnimationDelay: true,
            supportsAnimationLength: true,
            supportsStackedTypes: true,
            supportsLegend: true,
            supportsLegendOrientation: true,
            supportsShowYAxis: true,
            supportsMainColor: true,
            supportsHistory: true,
            supportsThemeTypography: true,
            thumbSrc: 'template-stacked-column-chart.jpg',
            supportsThemeColor: true,
            tunables: HyperSpaceStackedColumnChartWidgetTunables,
            supportsSortBy: true,
        })
    );

    // hyperspace treeMap
    indexedList.add(
        new WidgetTypeWrapper({
            id: 'hyperSpaceTreeMap',
            idTemplate: 'hyper-space-tree-map',
            name: 'Tree Map',
            dataType: 'analytics',
            component: HyperSpaceTreeMapWidget,
            supportsWidgetLabelDateRange: true,
            tags: ['analytics'],
            minProjections: 1,
            maxProjections: 12,
            minGroupBys: 0,
            maxGroupBys: 1,
            supportsPanelPadding: true,
            supportsPreviousPeriod: true,
            groupByLabels: ['x', 'series'],
            optionsType: HyperSpaceTreeMapWidgetOptionsImpl,
            supportsWidgetLabel: true,
            supportsLabel: true,
            supportsColorPalette: true,
            supportsDisableColorPalette: true,
            supportsSpacingMax: 25,
            supportsPadding: true,
            supportsPaddingMin: 15,
            supportsPaddingMax: 35,
            // supportsAnimationTypes: ['fade', 'drop', 'lift', 'slide_in_out', 'scale_in_out'],
            supportsAnimationTunables: false,
            supportsAnimation: false,
            supportsPresentationsPlayer: false,
            supportsAnimationDelay: false,
            supportsAnimationLength: false,
            supportsThresholds: true,
            supportsHistory: true,
            supportsBlacklist: true,
            supportsMainColor: true,
            supportsThemeTypography: true,
            supportsSentiment: true,
            thumbSrc: 'template-tree-map.jpg',
            supportsThemeColor: true,
            supportsThemeImage: true,
            supportsThemeImageOpacity: false,
            supportsThemeImageCircleMask: true,
            supportsThemeImageSize: true,
            supportsThemeImagePosition: true,
            supportsSortBy: true,
            tunables: HyperSpaceTreeMapWidgetTunables,
        })
    );
    // hyperspace hyperSpaceAlerts
    indexedList.add(
        new WidgetTypeWrapper({
            id: 'hyperSpaceAlerts',
            idTemplate: 'hyper-space-alerts',
            featureFlagControlled: [FEATURE_FLAG.STORYBOARD_ALERTS],
            name: 'Alerts',
            dataType: 'posts',
            component: HyperSpaceAlertsWidget,
            supportsWidgetLabelDateRange: true,
            tags: ['posts'],
            minProjections: 1,
            maxProjections: 12,
            minGroupBys: 0,
            maxGroupBys: 1,
            supportsPanelPadding: true,
            supportsPreviousPeriod: false,
            groupByLabels: ['x', 'series'],
            optionsType: HyperSpaceAlertsWidgetOptionsImpl,
            supportsWidgetLabel: true,
            supportsLabel: true,
            supportsColorPalette: true,
            supportsDisableColorPalette: true,
            supportsSpacingMax: 25,
            supportsPadding: true,
            supportsPaddingMin: 15,
            supportsPaddingMax: 35,
            supportsAnimationTypes: ['fade', 'drop', 'lift', 'slide_in_out', 'scale_in_out'],
            supportsAnimationTunables: true,
            supportsAnimation: true,
            supportsAnimationDelay: true,
            supportsAnimationLength: true,
            supportsThresholds: true,
            supportsHistory: true,
            supportsBlacklist: true,
            supportsMainColor: true,
            supportsThemeTypography: false,
            supportsSentiment: false,
            thumbSrc: 'template-tree-map.jpg',
            supportsThemeColor: false,
            supportsThemeImage: false,
            supportsThemeImageOpacity: false,
            supportsThemeImageCircleMask: false,
            supportsThemeImageSize: false,
            supportsThemeImagePosition: false,
            supportsSortBy: true,
            tunables: HyperSpaceAlertsWidgetTunables,
        })
    );
};
